import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **ResNexus**
 *
 *
 * @exports bs_195
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_195
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const langEl = document.querySelector('#Languages').value;
            if (langEl && ctx.langs.test(langEl)) {
                resolve(langEl);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_195
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#right-wrapper') || document.querySelector('.desktop-grid');
        if (container && !thn.resnexusObserver) {
            thn.resnexusObserver = thn.debounce(function thnResnexusObserver() {
                ctx.widget.refresh();
            }, 600);
            thn.observeDom(container, thn.resnexusObserver, {
                childList: true,
                subtree: true,
                attributes: false,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(container, thn.resnexusObserver);
                delete thn.resnexusObserver;
            });
        }
    };
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        const widgetData = {};
        if (window.location.pathname.match(/(M|m)obile/) || !window.location.hostname.match(/reserve4.resnexus.com/)) {
            return widgetData;
        }
        // Dates
        const dateBegin = ((document.querySelector('#checkinField') || {}).value || thn.parseUrlParameter('StartDate')).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
        const dateEnd = ((document.querySelector('#checkoutField') || {}).value || thn.parseUrlParameter('EndDate')).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
        let nights;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Adults
        const adults = thn.parseNumber((document.querySelector('#displayAdultsNumber') || {}).textContent);
        widgetData.adults = adults;
        widgetData.rooms = 1;
        widgetData.children = 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // Prices - No rooms
        const priceSelector = document.querySelectorAll('.price');
        // in some properties we have a number that interferes with the parse_number. So I use substring to cut the right part of the textContent
        const prices = [...priceSelector].map((elm) => {
            if (!elm.textContent.includes('%')) {
                return thn.parseNumber(elm.textContent.substring(elm.textContent.indexOf('$')));
            }
            return false;
        }).filter(Boolean);
        if (prices.length && nights) {
            // some properties show the price per stay
            const perNight = (priceSelector[0].textContent || '').match(/per\snight/);
            widgetData.price = perNight ? Math.min(...prices) : (Math.min(...prices) / nights).toFixed(2);
            const currency = (document.querySelector('.tab.smalltab') || document.querySelector('.price') || {}).textContent;
            widgetData.currency = (currency && thn.parseCurrency(currency)) || 'USD';
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        // Mobile version
        const widgetData = {};
        if (!window.location.pathname.match(/mobile/i)) {
            return widgetData;
        }
        // Dates
        let nights;
        const nightsSelector = document.querySelectorAll('.action-buttons .action-button') && document.querySelectorAll('.action-buttons .action-button')[2];
        if (nightsSelector) {
            nights = nightsSelector.querySelectorAll('tr td.action-button-num') && nightsSelector.querySelectorAll('tr td.action-button-num')[0];
            widgetData.nights = thn.parseNumber(nights.textContent);
        }
        const dateBeginSelector = document.querySelectorAll('.date-and-page-bar .inner');
        let dateBegin = dateBeginSelector.length > 0 && dateBeginSelector[1] && (dateBeginSelector[1].textContent || '').trim();
        let dateEnd;
        if (dateBegin && widgetData.nights) {
            dateBegin = translateDate(dateBegin, thn.data.language);
            dateEnd = thn.addDays(dateBegin, widgetData.nights).toDateString();
            dateEnd = translateDate(dateEnd, thn.data.language);
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
        }
        // Guests
        const guestsSelector = document.querySelectorAll('.action-buttons .action-button') && document.querySelectorAll('.action-buttons .action-button')[3];
        if (guestsSelector) {
            const adults = guestsSelector.querySelectorAll('tr td.action-button-num') && guestsSelector.querySelectorAll('tr td.action-button-num')[0];
            widgetData.adults = thn.parseNumber(adults.textContent);
            widgetData.children = 0;
            widgetData.guests = widgetData.adults + widgetData.children;
        }
        // Prices
        const priceSelector = document.querySelectorAll('#listings-wrapper td.name');
        const prices = [...priceSelector].map(function (elm) {
            if (elm.textContent.match(/\$/)) {
                return thn.parseNumber(elm.textContent.substring(elm.textContent.indexOf('$')));
            }
            return '';
        }).filter(Boolean);
        const currency = thn.parseCurrency(priceSelector[1].textContent || '');
        // some properties show the price per stay
        if (prices.length && widgetData.nights) {
            const perNight = (priceSelector[1].textContent || '').match(/per\snight/);
            widgetData.price = perNight ? Math.min(...prices) : (Math.min(...prices) / widgetData.nights).toFixed(2);
            widgetData.currency = currency || 'USD';
            widgetData.set = true;
        }
        return widgetData;
    };
    engine.priceParseData_v3 = function priceParseData_v3(ctx) {
        // New version of the BE for properties 1027650 and 1033459. Valid for Desktop & Mobile.
        const widgetData = {};
        if (window.location.hostname.match(/reserve4.resnexus.com/)) {
            return widgetData;
        }
        const searchInfo = ((document.querySelector('.infoAlert') || {}).textContent || '').trim().split('-');
        if (searchInfo && searchInfo.length > 2) {
            // Dates
            const dateBegin = translateDate(searchInfo[0] || '', thn.data.language || 'en');
            const dateEnd = translateDate(searchInfo[1] || '', thn.data.language || 'en');
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            // Guests, Adults & Children (this information is in search_info[2])
            const adultsRegexp = /^ [0-9]* Adults/;
            const childRegexp = /[0-9]* Children/;
            widgetData.adults = (searchInfo[2].match(childRegexp) && thn.parseNumber(searchInfo[2].match(adultsRegexp)[0])) || 2;
            widgetData.children = (searchInfo[2].match(childRegexp) && thn.parseNumber(searchInfo[2].match(childRegexp)[0])) || 0;
            widgetData.guests = widgetData.adults + widgetData.children;
        }
        // price & currency
        const noAvailability = document.querySelector('.noResults');
        if (noAvailability) {
            widgetData.noRooms = true;
            return widgetData;
        }
        const priceList = Array.from(document.querySelectorAll('.rate-price-per-night')).map((el) => thn.parseNumber(el.textContent));
        const currencySelector = document.getElementById('Currency');
        const currency = currencySelector && thn.parseCurrency(currencySelector.options[currencySelector.selectedIndex].text);
        if (!thn.empty(priceList) && currency) {
            widgetData.price = Math.min(...priceList);
            widgetData.currency = currency;
            widgetData.set = true;
        }
        return widgetData;
    };
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // Dates are not worth getting, because there are no classes, it's all br, spans and tables, and they change in each property
        // The price doesn't appear in the new version of the BE so we only get them from the old one.
        const oldBe = window.location.hostname.match(/reserve4.resnexus.com/);
        let priceArray;
        let price;
        if (oldBe) {
            priceArray = [...document.querySelectorAll('.item-price')];
            price = (priceArray[priceArray.length - 1] || {}).textContent;
            if (price) {
                widgetData.currency = thn.parseCurrency(price);
                widgetData.price = thn.parseNumber(price);
            }
        }
        const bookingId = (document.querySelector('.final-reservation-title') || document.querySelector('.confirmation-number') || {}).textContent.trim();
        if (bookingId) {
            widgetData.bookingId = bookingId;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
